import React, { useMemo } from 'react'
import { SectionHeader } from '../schedule/SectionHeader'
import { DateMatches } from './MatchLevelPlayoffDateSchedule'
import { gEnums } from 'global/enums/globalEnums'
import { _matchDisplayTypes } from './MatchContent'
import { MatchesDate } from './MatchesDate'

export const SectionSchedule = ({
  levelKey,
  sectionKey,
  matches_sections,
  dateKey,
  teamKey,
  matchDisplayType = _matchDisplayTypes.scoreboard,
  matchScheduleDisplayType = gEnums.matchScheduleDisplayTypes.scoreboard,
  team_fav_keys = [],
}) => {

  const sectionHeader = <SectionHeader sectionKey={sectionKey} levelKey={levelKey} />

  const sectionMatches = useMemo(() => {
    const matches_section = !_.isEmpty(matches_sections) ? <MatchesDate
      levelKey={levelKey}
      sectionKey={sectionKey}
      dateKey={dateKey}
      matches={matches_sections}
      teamKey={teamKey}
      matchDisplayType={matchDisplayType}
      matchScheduleDisplayType={matchScheduleDisplayType}
      team_fav_keys={team_fav_keys}
    /> : <div>No Matches</div>
    return matches_section
  }, [matches_sections])

  const div_section = <div className='match-date-matches'>
    {sectionHeader}
    {sectionMatches}
  </div>

  return div_section

}
